import { PagedRequestDto } from './../paged-request.model';
export interface CorporateOnboardingRecordsParameters extends PagedRequestDto {
  /**
   * format: date-time
   */
  submittedFrom: string;
  /**
   * format: date-time
   */
  submittedTo: string;
}
